module.exports = __webpack_public_path__ + "static/show-hero-720cd5cceb876b045c8f846515b8835e.jpg";